// Allows to contain items with col-* classes (like sdx-dialog-content)
@import "stylesheets/sdx/grid/grid";

:host {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: $zindex-topmost - 1;

  // Needed for macOS Safari 16.3 (and also iOS 16)
  -webkit-backdrop-filter: blur(4px) brightness(50%);
}

.component {
  height: var(--sdx-dialog-window-inner-height, 100%);

  .background {
    position: absolute;
    height: 100%;
    width: 100%;
  }

  // because sdx-backdrop is the parent of sdx-dialog-content and it creates the possibility for col-* classes
  .slot {
    position: relative; // overlap absolute
    height: 100%;
  }
}
